import React, { useState } from 'react'

import { TextField, Box, Button, CircularProgress } from '@mui/material'
import { Check } from '@mui/icons-material'

const NewTodo = ({ onCommit, onCancel }) => {
  const [dueDate, setDueDate] = useState(new Date().toLocaleDateString('sv'))
  const [note, setNote] = useState('')

  const [loading, setLoading] = useState(false)

  return (
    <Box>
      {loading && <CircularProgress />}
      {!loading && (
        <>
          <TextField
            label={'Due Date'}
            type={'date'}
            margin='dense'
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
          ></TextField>

          <TextField
            label={'Description'}
            margin={'dense'}
            fullWidth
            value={note}
            onChange={(e) => setNote(e.target.value)}
          ></TextField>
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button onClick={onCancel} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              variant={'contained'}
              endIcon={<Check />}
              onClick={() => {
                setLoading(true)
                onCommit({ dueDate, note }, () => setLoading(false))
              }}
              color={'primary'}
            >
              Create
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}

export default NewTodo
